import ActivePipeIcon from 'assets/icons/ActivePipeIcon.png';
import ActiveAcceptedPipeIcon from 'assets/icons/ActiveAcceptedPipeIcon.png';
import ActiveRejectedPipeIcon from 'assets/icons/ActiveRejectedPipeIcon.png';
import ActiveAcceptedBundIcon from 'assets/icons/ActiveAcceptedBundIcon.png';
import ActiveRejectedBundIcon from 'assets/icons/ActiveRejectedBundIcon.png';
import AcceptedPipeIcon from 'assets/icons/AcceptedPipeIcon.png';
import ActiveBundIcon from 'assets/icons/ActiveBundIcon.png';
import AcceptedBundIcon from 'assets/icons/AcceptedBundIcon.png';
import InactiveBundIcon from 'assets/icons/InactiveBundIcon.png';
import InactivePipeIcon from 'assets/icons/InactivePipeIcon.png';
import MachineGeneratedPointIcon from 'assets/icons/MachineGeneratedPointIcon.png';
import NeighbouringUserGeneratedPointIcon from 'assets/icons/NeighbouringUserGeneratedPointIcon.png';
import RejectedPipeIcon from 'assets/icons/RejectedPipeIcon.png';
import RejectedBundIcon from 'assets/icons/RejectedBundIcon.png';
import RoundMarkerIcon from 'assets/icons/RoundMarkerIcon.png';
import DefaultLiveMachineIcon from 'assets/icons/DefaultLiveMachineIcon.svg';
import SelectedLiveMachineIcon from 'assets/icons/SelectedLiveMachineIcon.svg';
import TriangleRed from 'assets/icons/TriangleRed.svg';
// import TrianglePink from 'assets/icons/TrianglePink.svg';
import ArrowBlue from 'assets/icons/ArrowBlue.svg';
import ArrowGreen from 'assets/icons/ArrowGreen.svg';
import ArrowYellow from 'assets/icons/ArrowYellow.svg';
import ArrowRed from 'assets/icons/ArrowRed.svg';
import CircleRed from 'assets/icons/CircleRed.svg';
import CirclePink from 'assets/icons/CirclePink.svg';
import CircleYellow from 'assets/icons/CircleYellow.svg';
import SquareBlue from 'assets/icons/SquareBlue.svg';
import SquareGreen from 'assets/icons/SquareGreen.svg';
import SquareRed from 'assets/icons/SquareRed.svg';
import PathEdgeMarker from 'assets/icons/PathEdgeMarker.svg';

// import OtherPointIcon from 'assets/icons/OtherPointIcon.png';

export const iconsMap: any = {
	'ACTIVE-PIPE': ActivePipeIcon,
	'ACTIVE-ACCEPTED-PIPE': ActiveAcceptedPipeIcon,
	'ACTIVE-REJECTED-PIPE': ActiveRejectedPipeIcon,
	'ACCEPTED-PIPE': AcceptedPipeIcon,
	'INACTIVE-PIPE': InactivePipeIcon,
	'REJECTED-PIPE': RejectedPipeIcon,
	'ACTIVE-BUND': ActiveBundIcon,
	'ACTIVE-ACCEPTED-BUND': ActiveAcceptedBundIcon,
	'ACTIVE-REJECTED-BUND': ActiveRejectedBundIcon,
	'ACCEPTED-BUND': AcceptedBundIcon,
	'INACTIVE-BUND': InactiveBundIcon,
	'REJECTED-BUND': RejectedBundIcon,
	'ROUND-MARKER': RoundMarkerIcon,
	'OTHER-POINT': NeighbouringUserGeneratedPointIcon,
	'MACHINE-GENERATED': MachineGeneratedPointIcon,
	'DEFAULT-LIVE-MACHINE': DefaultLiveMachineIcon,
	'SELECTED-LIVE-MACHINE': SelectedLiveMachineIcon,
	'TRIANGLE-RED': TriangleRed,
	'CIRCLE-RED': CircleRed,
	'SQUARE-RED': SquareRed,
	'ARROW-RED': ArrowRed,
	'ARROW-YELLOW': ArrowYellow,
	'CIRCLE-YELLOW': CircleYellow,
	'CIRCLE-PINK': CirclePink,
	'ARROW-BLUE': ArrowBlue,
	'SQUARE-BLUE': SquareBlue,
	'ARROW-GREEN': ArrowGreen,
	'SQUARE-GREEN': SquareGreen,
	'DEFAULT-ARROW': PathEdgeMarker,
};

export const iconSizeToZoomMap: Record<
	string,
	{ iconSizeFactor: number; anchorValueFactor: number }
> = {
	'19': { iconSizeFactor: 1, anchorValueFactor: 1 },
	'18': { iconSizeFactor: 1.5, anchorValueFactor: 1.25 },
	'17': { iconSizeFactor: 2, anchorValueFactor: 2.5 },
	// '16': { iconSizeFactor: 2.5, anchorValueFactor: 2 },
	// '15': { iconSizeFactor: 3, anchorValueFactor: 2 },
};
